"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _HeartModule = _interopRequireDefault(require("./Heart.module.css"));

var _grommet = require("grommet");

var _reactLottie = _interopRequireDefault(require("react-lottie"));

var _heart = _interopRequireDefault(require("./heart.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//import * as firebase from 'firebase/app';
//import { db } from '../../index.js';
// import { relativeTimeThreshold } from 'moment';
var Heart = /*#__PURE__*/function (_React$Component) {
  _inherits(Heart, _React$Component);

  var _super = _createSuper(Heart);

  function Heart(props) {
    var _this;

    _classCallCheck(this, Heart);

    _this = _super.call(this, props);
    _this.state = {
      heart: _this.props.heart,
      filled: "",
      empty: ""
    };
    _this.changeFavorite = _this.changeFavorite.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Heart, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.heart !== this.props.heart) {
        this.setState({
          heart: this.props.heart
        });
      }
    }
  }, {
    key: "changeFavorite",
    value: function changeFavorite() {
      var _this2 = this;

      var clubUUID = this.props.clubUUID;
      var favorited = this.state.heart;
      this.setState(function (prevState) {
        return {
          heart: !prevState.heart
        };
      });

      if (this.props.changeHeart !== undefined) {
        this.props.changeHeart();
      }

      if (favorited) {
        this.props.heartFn("unlike", clubUUID, this.props.email, function () {
          if (_this2.props.addToLocalMailingList != undefined) {
            _this2.props.addToLocalMailingList("leave", clubUUID, _this2.props.token, _this2.props.email);
          }
        });
        /*
        firebase.auth().currentUser.getIdToken()
        .then((idToken) =>{
            /*
            const date = new Date();
            window.ga('send', 'event', 'Club Interaction', 'Unfavorited');
            db.collection('logged_events').add({
                'category': 'Club Interaction',
                'action': 'Unfavorited',
                'time': date,
                'user': idToken,
                'club': this.props.clubUUID,
                'url': window.location.href,
            });
            
            fetch(
                'https://covid-response-tool.herokuapp.com/api/reactToClub/', 
                {
                    method: 'POST', 
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        token: idToken,
                        clubUUID: clubUUID,
                        action: "unlike"
                    }),
                }
            )
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);
            })
            .catch((error) => console.log(error));
            fetch(
                'https://covid-response-tool.herokuapp.com/api/editMailingList/', 
                {
                    method: 'POST', 
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        token: idToken,
                        clubUUID: clubUUID,
                        action: "leave",
                        email: this.props.email
                    }),
                }
            )
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);
                return response.json();
            })
            .then((data) => {
                this.props.addToLocalMailingList("leave", clubUUID, this.props.token, this.props.email);
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => console.log(error));
        */
      } else {
        this.props.heartFn("like", clubUUID, this.props.email, function () {
          if (_this2.props.addToLocalMailingList != undefined) {
            _this2.props.addToLocalMailingList("join", clubUUID, _this2.props.token, _this2.props.email);
          }
        });
        /*
        firebase.auth().currentUser.getIdToken()
        .then((idToken) =>{
            const date = new Date();
            window.ga('send', 'event', 'Club Interaction', 'Favorited');
            db.collection('logged_events').add({
                'category': 'Club Interaction',
                'action': 'Favorited',
                'time': date,
                'user': idToken,
                'club': this.props.clubUUID,
                'url': window.location.href,
            });
            fetch(
                'https://covid-response-tool.herokuapp.com/api/reactToClub/', 
                {
                    method: 'POST', 
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        token: idToken,
                        clubUUID: clubUUID,
                        action: "like",
                    }),
                }
            )
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);
                return response.json();
            })
            .then((data) => {
             })
            .catch((error) => console.log(error));
            fetch(
                'https://covid-response-tool.herokuapp.com/api/editMailingList/', 
                {
                    method: 'POST', 
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        token: idToken,
                        clubUUID: clubUUID,
                        action: "join",
                        email: firebase.auth().currentUser.email
                    }),
                }
            )
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);
                return response.json();
            })
            .then((data) => {
                this.props.addToLocalMailingList("join", clubUUID, firebase.auth().currentUser.uid, firebase.auth().currentUser.email);
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => console.log(error));
        */
      }

      if (this.props.unfavorite !== undefined) {
        this.setState({
          heart: true
        });
        this.props.unfavorite(this.props.clubUUID);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: _heart["default"],
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
      var opacity = .25;

      if (this.props.changeHeart === undefined) {
        opacity = 1;
      }

      return /*#__PURE__*/_react["default"].createElement("div", null, this.state.heart ? /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
        onClick: this.changeFavorite,
        id: _HeartModule["default"].lottie
      }, /*#__PURE__*/_react["default"].createElement(_reactLottie["default"], {
        options: defaultOptions,
        height: "115px",
        width: "115px",
        id: _HeartModule["default"].lottie
      })) : /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
        style: {
          opacity: opacity
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        onClick: this.changeFavorite,
        id: _HeartModule["default"].heart,
        alt: "unselected",
        src: this.props.empty
      })));
    }
  }]);

  return Heart;
}(_react["default"].Component);

var _default = Heart;
exports["default"] = _default;

//# sourceMappingURL=Heart.js.map